import axios, {AxiosInstance, AxiosRequestConfig, AxiosResponse} from "axios";
import { buildRequestHeader } from "@/shared/services/helper/utils";
import { notification } from "ant-design-vue";
import NProgress from "nprogress";
import {AuthStore} from "@/modules/auth/store";


const http: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 5 * 60 * 1000
});

const errorHandler = (error: any) => {
    // if (error?.response?.status === 401) {
    //     notification.error({
    //         message: "Bạn chưa xác thực",
    //         description: "Vui lòng đăng nhập lại"
    //     });
    //     AuthStore.logout();
    // }
    if (error?.response?.status === 403) {
        notification.error({
            message: "Từ chối truy cập",
            description: "Bạn không có quyền truy cập tài nguyên này"
        });
        // AuthStore.logout();
    }
    NProgress.done();
    return Promise.reject(error);
};

http.interceptors.request.use((config: AxiosRequestConfig) => {
    NProgress.start();
    config.headers = buildRequestHeader();
    return config;
}, errorHandler);

http.interceptors.response.use((response: AxiosResponse) => {
    NProgress.done();
    return response;
}, errorHandler);

export default http